/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, time: NonNullable<unknown> }} Date_AtInputs */



/**
* | output |
* | --- |
* | "{date} at {time}" |
*
* @param {Date_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_at = /** @type {((inputs: Date_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.date} at ${i?.time}`)
	return /** @type {LocalizedString} */ (`${i?.date} à ${i?.time}`)
});